import classNames from "classnames";
import {Svg} from "@/shared/ui/Svg";
import {FooterSocial} from "../../model/types";
import styles from "../Footer.module.scss";

type Props = {
    socials: FooterSocial[];
    className: string;
}

export const FooterSocials = ({socials = [], className}: Props) => {
    return (
        <div className={classNames(styles.socialsContainer, className)}>
            <p className={styles.navItemTitle}>Мы в социальных сетях</p>
            <div className={styles.socialsIcons}>
                {socials.map((social) => (
                    <a
                        key={social.href}
                        href={social.href}
                        rel="noopener noreferrer"
                        className={classNames(styles.socialsIcon, styles[social.svgName])}
                        target={`_blank`}
                    >
                        <Svg id={social.svgName} className={classNames(styles.svgIcon, styles[social.svgName])} />
                    </a>
                ))}
            </div>
        </div>
    );
}
